import {
    FETCH_RASPA_CYCLE_HOUR_USAGE_STATISTICS, FETCH_ROITREAD_CYCLE_HOUR_USAGE_STATISTICS,

    FETCH_ROITREAD_CYCLES, RECEIVE_RASPA_CYCLE_HOUR_USAGE_STATISTICS, RECEIVE_ROITREAD_CYCLE_HOUR_USAGE_STATISTICS,
    RECEIVE_ROITREAD_CYCLES
} from "../actions/actionTypes";

const initalState = {
    isFetchingRoitreadCycles: false,
    RoitreadCycles: [],
    RoitreadCycleStatistics: {
        hourUsageTotals: [],
        buffingStatsPerSaw: [],
        BuffingStatsPerSawPerOperator: [],
        buffingStatsPerSawPerOperator: [],
        roitreadRithmPerOperator: [],
        ExtrusionComsuptionPerTireSize: []

    }
}

export default (state = initalState, action) => {
    switch(action.type) {
        case FETCH_ROITREAD_CYCLES:
            return {
                ...state,
                isFetchingRoitreadCycles: true
            }
        case RECEIVE_ROITREAD_CYCLES:
             console.log('reducer receive ', action.payload);
            return {
                ...state,
                isFetchingRoitreadCycles: false,
                RoitreadCycles: action.payload
            }
            break;
        case FETCH_ROITREAD_CYCLE_HOUR_USAGE_STATISTICS:
            console.log('reducer receive ', action.payload);
            return {
                ...state,
                isFetchingRaspaCycleStatistics: true,
                RoitreadCycleStatistics: action.payload
            }
            break;
        case RECEIVE_ROITREAD_CYCLE_HOUR_USAGE_STATISTICS:
            console.log('reducer receive ', action.payload);
            return {
                ...state,
                isFetchingRaspaCycleStatistics: false,
                RoitreadCycleStatistics: action.payload
            }
            break;
        default:
            return state;
    }
}
